import styled from 'styled-components';

export const HeadSection = styled.div`
  overflow: hidden;
`;
